import React, { useState } from 'react';
import { map } from 'rxjs/operators';
import { withAppContext } from '@ctsu/loader';
import bindLogger from 'helpers/BindLogger';
import { getProtocol } from 'actions/irb';
import TypeAhead from './TypeAhead';

const fetchData = (context, searchText) => bindLogger(
  getProtocol,
  context
)(searchText).pipe(
  map((resp) => {
    const { response } = resp;
    if (response != null && response.length > 0) {
      return response.map((r) => {
        const { protocolNumber, status } = r;
        return {
          label: `${protocolNumber} (${status})`,
          value: protocolNumber,
          status
        };
      });
    }
    return [];
  })
);

function ProtocolTypeahead({
  context, onChange, value, isDisabled = false, name = 'Protocol'
}) {
  const [options, setOptions] = useState([]);

  const fetchOptions = (searchText) => {
    if (searchText == null || searchText.trim().length < 3) {
      setOptions([]);
      return;
    }
    fetchData(context, searchText).subscribe(setOptions);
  };

  return (
    <TypeAhead
      name={name}
      value={value}
      options={options}
      onChange={onChange}
      onChangeText={fetchOptions}
      isDisabled={isDisabled}
    />
  );
}

export default withAppContext(ProtocolTypeahead);
